import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { HEALTH_SLICE_NAME } from "./health.constants"

/* ------------- Overview dashboard ------------- */

export const getHealthMainInfo = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_health_main_info`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHealthMainInfo(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getHealthOverview = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_health_overview`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getHealthOverview(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getPreventionRate = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_prevention_rate`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getPreventionRate(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getDataByCardType = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_data_by_card_type`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getDataByCardType(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getDataByCountry = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_data_by_country`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getDataByCountry(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getDataByReasonCode = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_data_by_reason_code`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getDataByReasonCode(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getDataOlympics = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_data_olympics`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getDataOlympics(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getRiskLevel = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_risk_level`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getRiskLevel(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getFilterOptions = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_filter_options`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getFilterOptions(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- VAMP (Visa) ------------- */

export const getVampMainChart = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_vamp_main_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getVampMainChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getVampMonitoringProgramChart = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_vamp_monitoring_program_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getVampMonitoringProgramChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getVampEstimatedProgramStatus = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_vamp_estimated_program_status`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getVampEstimatedProgramStatus(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getVampDescriptors = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_vamp_descriptors`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getVampDescriptorsList(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Mastercard (ECP & EFM) ------------- */

export const getMcMainChart = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_mc_main_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getMcMainChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getMcMonitoringProgramChart = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_mc_monitoring_program_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getMcMonitoringProgramChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getEfmMonitoringProgramChart = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_efm_monitoring_program_chart`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getEfmMonitoringProgramChart(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getMcEstimatedProgramStatus = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/get_mc_estimated_program_status`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getMcEstimatedProgramStatus(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

/* ------------- Monitoring bootstrap ------------- */

// Was `monitoringInitSaga`: two requests in sequence, each with its own failure message and
// no global error notification - the page renders `monitoringInitError` itself. The legacy
// MONITORING_INIT / _SUCCESS / _FAILURE triplet maps onto this thunk's pending / fulfilled /
// rejected, so no plain actions are needed for it.
export const monitoringInit = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/monitoring_init`,
  async (payload, { rejectWithValue }) => {
    const { business_account } = payload || {}
    try {
      const descriptorsListRes = await services.getVampDescriptorsList({ business_account })
      const enrollmentDataRes = await services.getVampEnrollmentData({ business_account })

      // Enrollment data is checked first even though descriptors are requested first - same
      // order the saga used, so the same message wins when both calls fail.
      if (!enrollmentDataRes.ok || !enrollmentDataRes.data) {
        return rejectWithValue({ message: "Failed to fetch enrollment data" })
      }
      if (!descriptorsListRes.ok || !descriptorsListRes.data) {
        return rejectWithValue({ message: "Failed to fetch descriptors list" })
      }

      return {
        descriptorsList: descriptorsListRes.data,
        enrollmentData: enrollmentDataRes.data,
        business_account
      }
    } catch (e) {
      return rejectWithValue({ message: "Monitoring initialization failed" })
    }
  }
)

export const createVampEnrollment = createAsyncThunk(
  `${HEALTH_SLICE_NAME}/create_vamp_enrollment`,
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await services.createVampEnrollmentRequest(payload)
      if (!response.ok) {
        return rejectWithValue({ message: "Failed to create VAMP enrollment" })
      }
      // The saga re-ran the monitoring bootstrap after a successful enrollment.
      dispatch(monitoringInit({ business_account: payload?.business_account }))
      return { enrollmentData: response.data }
    } catch (e) {
      return rejectWithValue({ message: "VAMP enrollment request failed" })
    }
  }
)
